module.exports = __webpack_public_path__ + "img/aParty_110923_E.cffdb74a.jpg";